module.exports = __webpack_public_path__ + "img/pwa-role-select.a9da86f5.png";